const SEARCH_ENDPOINT = 'https://api.media-matchers.com/search'

/**
 * Default publisher group for the find-degrees theme landing pages. A
 * `mPubGroupID` on the page URL replaces it, so a campaign can attribute its
 * own traffic without a code change.
 */
export const FIND_DEGREES_PUB_GROUP_ID = 'PCGP6719653065'

/**
 * Builds the Media Matchers click-out for a find-degrees CTA.
 *
 * Every query parameter on the current page URL is forwarded, so tracking and
 * targeting context a campaign puts on the landing URL reaches the partner
 * untouched. `redirect=1` sends the visitor straight through to the school
 * rather than returning JSON.
 */
export function buildFindDegreesClickout(
  search: string = typeof window === 'undefined' ? '' : window.location.search,
  /**
   * Page context (degreeInterest / areaStudy / mProgram). The incoming URL
   * still wins, so a campaign can override what the page would send.
   */
  context: Record<string, string | undefined> = {},
): string {
  // Start from the incoming URL so every param passes through as-is.
  const params = new URLSearchParams(search)

  for (const [key, value] of Object.entries(context)) {
    const trimmed = value?.trim()
    if (trimmed && !params.get(key)?.trim()) {
      params.set(key, trimmed)
    }
  }

  // Always a redirect — this is a click-out, not a data fetch.
  params.set('redirect', '1')

  // The page default only applies when the URL didn't specify a group.
  if (!params.get('mPubGroupID')?.trim()) {
    params.set('mPubGroupID', FIND_DEGREES_PUB_GROUP_ID)
  }

  return `${SEARCH_ENDPOINT}?${params.toString()}`
}
